import { render, staticRenderFns } from "./payDetail.vue?vue&type=template&id=3bd7dbd5&"
import script from "./payDetail.vue?vue&type=script&lang=js&"
export * from "./payDetail.vue?vue&type=script&lang=js&"
import style0 from "./payDetail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports